import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
} from "@mui/material";

const UserSelectionModal = ({ open, onClose, users = [], onSelectUser, isLoading = false }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            disableEnforceFocus // Add this to prevent focus issues
            disableAutoFocus={false} // Allow auto focus
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PersonIcon sx={{ color: "#0b756c" }} />
                    <span>Select User ({users.length} found for your query)</span>
                </Box>
                <IconButton onClick={onClose} size="small" aria-label="Close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                {isLoading ? (
                    <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <svg width="48" height="48" viewBox="0 0 50 50">
                            <circle cx="25" cy="25" r="20" fill="none" stroke="#0b756c" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
                                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    </Box>
                ) : users.length > 0 ? (
                    <List sx={{ p: 0 }}>
                        {users.map((user, idx) => (
                            <ListItem key={user._id || user.email || idx} disablePadding>
                                <ListItemButton
                                    onClick={() => {
                                        onSelectUser(user);
                                    }}
                                    sx={{
                                        py: 2,
                                        px: 3,
                                        borderBottom: idx < users.length - 1 ? "1px solid #f0f0f0" : "none",
                                        "&:hover": {
                                            backgroundColor: "#f8fafc",
                                        },
                                    }}
                                    aria-label={`Select ${user.full_name || `${user.last_name}, ${user.first_name}`}`}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
                                        {/* Avatar */}
                                        <Box
                                            sx={{
                                                width: 48,
                                                height: 48,
                                                borderRadius: "50%",
                                                background: "#e0f7fa",
                                                color: "#0b756c",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: 700,
                                                fontSize: 18,
                                                border: "2px solid #b2ebf2",
                                                flexShrink: 0,
                                            }}
                                            aria-hidden="true"
                                        >
                                            {user.first_name?.[0] || user.last_name?.[0] || "U"}
                                        </Box>

                                        {/* User Info */}
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#222",
                                                    mb: 0.5,
                                                }}
                                            >
                                                {user.full_name || `${user.last_name}, ${user.first_name}`}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "#666",
                                                    fontSize: 13,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {user.email}
                                            </Typography>
                                            {(user.department || user.country) && (
                                                <Box sx={{ display: "flex", gap: 1, mt: 0.5, flexWrap: "wrap" }}>
                                                    {user.department && (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                background: "#e8f5e9",
                                                                borderRadius: 1,
                                                                px: 1,
                                                                py: 0.25,
                                                                fontSize: 11,
                                                            }}
                                                        >
                                                            {user.department}
                                                        </Typography>
                                                    )}
                                                    {user.country && (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                background: "#e0f7fa",
                                                                borderRadius: 1,
                                                                px: 1,
                                                                py: 0.25,
                                                                fontSize: 11,
                                                            }}
                                                        >
                                                            {user.country}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Typography sx={{ p: 3, textAlign: "center", color: "#888" }}>
                        No users found.
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UserSelectionModal;